import { createFileRoute, redirect } from "@tanstack/react-router";
import { ContractFormPage, isValidContractId } from "@/features/contracts/contract-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/$id")({
	beforeLoad: async ({ context, location, params }) => {
		// Nie-numeryczny segment (np. /kontrakty/raporty bez podstrony) nie jest
		// kontraktem — wracamy na liste zamiast strzelac /contracts/NaN.
		if (!isValidContractId(params.id)) {
			throw redirect({ to: "/kontrakty" });
		}
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.definicje",
			location.pathname,
		);
	},
	component: ContractFormPage,
});
